import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import ptBr from '@angular/common/locales/pt';
import {
	ApplicationConfig,
	inject,
	provideAppInitializer,
	provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideDateFnsAdapter } from '@angular/material-date-fns-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { provideRouter, TitleStrategy, withRouterConfig } from '@angular/router';
import { icons as lucideIcons } from '@iconify-json/lucide';
import { icons as svgSpinners } from '@iconify-json/svg-spinners';
import { addCollection } from '@iconify/iconify';
import { ptBR } from 'date-fns/locale';
import { mockApiInterceptor } from 'mocks/mock-api.interceptor';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { NavigationHistoryService } from 'services/navigation/navigation-history.service';
import { ThemeService } from 'services/theme/theme.service';
import { AppTitleStrategy } from 'services/title/title.strategy';
import { routes } from './app.routes';

registerLocaleData(ptBr);
addCollection(lucideIcons);
addCollection(svgSpinners);

export const appConfig: ApplicationConfig = {
	providers: [
		provideBrowserGlobalErrorListeners(),
		// Mesma configuração de router do Hub (o código dos produtos depende dela)
		provideRouter(
			routes,
			withRouterConfig({
				onSameUrlNavigation: 'reload',
				paramsInheritanceStrategy: 'always',
			}),
		),
		{ provide: TitleStrategy, useClass: AppTitleStrategy },
		// Sem backend: o código do Hub chama a API normalmente e o interceptor responde com mocks
		provideHttpClient(withFetch(), withInterceptors([mockApiInterceptor])),
		// Rastreia o histórico desde o início, para o lbca-back-button voltar para a tela anterior
		provideAppInitializer(() => {
			inject(ThemeService);
			inject(NavigationHistoryService);
		}),
		provideDateFnsAdapter(),
		{ provide: MAT_DATE_LOCALE, useValue: ptBR },
		provideCharts(withDefaultRegisterables()),
	],
};
